import { LoginView } from '@today/ui-domain'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import { stashPostLoginRedirect } from '@/auth/post-login-redirect'
import { useAuthLogo } from '@/auth/useAuthLogo'
import { useAuth } from '@/hooks/useAuth'
import { AUTH_NAMESPACE } from '@/i18n'

/** `/login` — the generic sign-in card; Continue starts the hosted login (TO-361 login-surface REQ-001). */
export function LoginPage() {
	const { login, isAuthenticated, isLoading } = useAuth()
	const { t } = useTranslation(AUTH_NAMESPACE)
	const logo = useAuthLogo()
	const navigate = useNavigate()
	const location = useLocation()
	const fromState = (location.state as { from?: string } | null)?.from
	const pendingRedirect = typeof fromState === 'string' ? fromState : null

	useEffect(() => {
		if (isAuthenticated) {
			void navigate(pendingRedirect ?? '/', { replace: true })
		}
	}, [isAuthenticated, navigate, pendingRedirect])

	const handleLogin = () => {
		if (pendingRedirect) stashPostLoginRedirect(pendingRedirect)
		login()
	}

	return (
		<LoginView
			logo={logo}
			isLoading={isLoading}
			onSignIn={handleLogin}
			labels={{
				title: t('login.title'),
				subtitle: t('login.subtitle'),
				action: t('login.action'),
				redirectHint: t('login.redirectHint'),
				loading: t('common.loading'),
			}}
		/>
	)
}
